import styled from 'styled-components';

import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H2 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const Wrapper = styled.div`
    width: 100%;
    padding-top: 64px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding-top: 24px;
    }
`;

export const TopBlock = styled.div`
    position: relative;
    width: 100%;
`;

export const HeadContent = styled.div`
    width: 100%;
    justify-content: space-between;
    margin-bottom: 32px;
`;

export const OffersInCity = styled(Paragraph4)`
    color: ${COLORS.TextDisabled};
`;

export const PageHeading = styled(H2)`
    margin: 4px 0 0;
`;

export const HeadingWrapper = styled.div`
    flex-direction: column;
`;

export const BottomBlock = styled.div`
    width: 100%;
    row-gap: 44px;

    @media(max-width: ${wideBreakpoints.laptop}) {
      row-gap: 24px;
    }
`;

export const StyledGridContainer = styled(WideContainer)`
    row-gap: 60px;
  
    @media(max-width: ${wideBreakpoints.laptop}) {
      row-gap: 40px;
    }
`;
